/* DHC v1052.30 — isolated PDP share/zoom + media-dot state. No cart/variant overrides. */
(function(){
  'use strict';
  function activeMedia(root){ return root && root.querySelector('.dhc-pdp__media-item.is-active'); }
  document.addEventListener('click', function(e){
    var share=e.target.closest('[data-dhc-pdp-share]');
    if(share){
      var payload={title:document.title,url:location.href};
      if(navigator.share){ navigator.share(payload).catch(function(){}); }
      else if(navigator.clipboard){ navigator.clipboard.writeText(location.href).then(function(){ share.textContent='Copied'; setTimeout(function(){share.textContent='Share';},1400); }).catch(function(){}); }
      return;
    }
    var zoom=e.target.closest('[data-dhc-pdp-zoom]');
    if(zoom){
      var root=zoom.closest('[data-product-gallery]'); var item=activeMedia(root); var img=item && item.querySelector('img');
      if(img && img.currentSrc){ window.open(img.currentSrc,'_blank','noopener'); }
      return;
    }
    var thumb=e.target.closest('[data-product-thumb]');
    if(thumb){
      var gallery=thumb.closest('[data-product-gallery]'); if(!gallery) return;
      var id=thumb.getAttribute('data-product-thumb');
      gallery.querySelectorAll('.dhc-pdp-v1052-30__dot').forEach(function(dot){dot.classList.toggle('is-active',dot.getAttribute('data-product-thumb')===id);});
    }
  }, false);
})();
